import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bc50416"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "field-name",
  for: "input-field-text"
}
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "empty-option"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "advise" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'form-group': true,
      'input-is-invalid': !!_ctx.validation_message,
      'input-readonly': _ctx.readonly,
    })
  }, [
    _createElementVNode("div", {
      class: "field-container",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show_options ? _ctx.hide() : _ctx.show()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({
          'input-field': true,
          'input-not-empty': _ctx.show_options || _ctx.selected,
          'manual-focus': _ctx.manual_focus,
        })
      }, [
        (_ctx.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          type: "text",
          class: _normalizeClass({ 'horario-picker': true, 'not-editable': true }),
          value: _ctx.selected?.label,
          autocomplete: "off",
          readonly: true,
          tabindex: "-1"
        }, null, 8, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass({
            'drop-icon-wrapper': true,
            'drop-open': _ctx.show_options,
          })
        }, [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                class: "drop-icon",
                icon: ['fa', 'caret-down']
              }))
            : _createCommentVNode("", true)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({
          'list-dropdown': true,
          'show-dowpdown': _ctx.show_options && !_ctx.readonly,
        })
      }, [
        (!_ctx.options?.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.empty_message), 1))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.options as OptionSelect[]), (op) => {
          return (_openBlock(), _createElementBlock("span", {
            key: op.value,
            class: _normalizeClass({ 'is-selected': _ctx.selected?.value == op.value }),
            onClick: ($event: any) => (_ctx.setSelected(op))
          }, _toDisplayString(op.label), 11, _hoisted_4))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!!_ctx.validation_message)
        ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
            key: 0,
            icon: "exclamation-circle"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.validation_message), 1)
    ])
  ], 2))
}